import {
  KidsPriceFormType,
  KidsPriceType,
  PriceFormType,
  ResponsePriceType,
  UpdatePriceType,
} from '../redux/types/pricesTypes';

export const comparePrices = (
  values: PriceFormType,
  prices: ResponsePriceType,
) => {
  const updatePrice: UpdatePriceType = {};
  if (
    prices?.base_price.high_season_weekday_price !==
    Number(values.base_price.high_season_weekday_price).toFixed(2).toString()
  ) {
    updatePrice.base_price = {};
    updatePrice.base_price.high_season_weekday_price = Number(
      values.base_price.high_season_weekday_price,
    )
      .toFixed(2)
      .toString();
  }
  if (
    prices?.base_price.high_season_weekend_price !==
    Number(values.base_price.high_season_weekend_price).toFixed(2).toString()
  ) {
    if (!updatePrice.base_price) {
      updatePrice.base_price = {};
    }
    updatePrice.base_price.high_season_weekend_price = Number(
      values.base_price.high_season_weekend_price,
    )
      .toFixed(2)
      .toString();
  }
  if (
    prices?.base_price.low_season_weekday_price !==
    Number(values.base_price.low_season_weekday_price).toFixed(2).toString()
  ) {
    if (!updatePrice.base_price) {
      updatePrice.base_price = {};
    }
    updatePrice.base_price.low_season_weekday_price = Number(
      values.base_price.low_season_weekday_price,
    )
      .toFixed(2)
      .toString();
  }
  if (
    prices?.base_price.low_season_weekend_price !==
    Number(values.base_price.low_season_weekend_price).toFixed(2).toString()
  ) {
    if (!updatePrice.base_price) {
      updatePrice.base_price = {};
    }
    updatePrice.base_price.low_season_weekend_price = Number(
      values.base_price.low_season_weekend_price,
    )
      .toFixed(2)
      .toString();
  }
  const newStartDate = values.start_date_month + '-' + values.start_date_day;
  if (prices?.base_price?.start_date !== newStartDate) {
    if (!updatePrice.base_price) {
      updatePrice.base_price = {};
    }
    if (updatePrice && updatePrice.base_price) {
      updatePrice.base_price.start_date = newStartDate;
    }
  }
  const newEndDate = values.end_date_month + '-' + values.end_date_day;
  if (prices?.base_price.end_date !== newEndDate) {
    if (!updatePrice.base_price) {
      updatePrice.base_price = {};
    }
    updatePrice.base_price.end_date = newEndDate;
  }
  if (prices?.is_animal_price_active !== values.isAnimalPrice) {
    updatePrice.is_animal_price_active = values.isAnimalPrice;
  }
  if (Number(prices?.animal_price) !== Number(values.animalPrice)) {
    updatePrice.animal_price = Number(values.animalPrice).toFixed(2).toString();
  }
  if (prices?.is_dynamic !== values.isPriceDynamic) {
    updatePrice.is_dynamic = values.isPriceDynamic;
  }
  if (
    prices?.extra_guest_price?.high_season_weekday_price !==
    Number(values.extra_guest_price.high_season_weekday_price)
      .toFixed(2)
      .toString()
  ) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.extra_guest_price.high_season_weekday_price = Number(
      values.extra_guest_price.high_season_weekday_price,
    )
      .toFixed(2)
      .toString();
  }
  if (
    prices?.extra_guest_price?.high_season_weekend_price !==
    Number(values.extra_guest_price.high_season_weekend_price)
      .toFixed(2)
      .toString()
  ) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.extra_guest_price.high_season_weekend_price = Number(
      values.extra_guest_price.high_season_weekend_price,
    )
      .toFixed(2)
      .toString();
  }
  if (
    prices?.extra_guest_price?.low_season_weekday_price !==
    Number(values.extra_guest_price.low_season_weekday_price)
      .toFixed(2)
      .toString()
  ) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.extra_guest_price.low_season_weekday_price = Number(
      values.extra_guest_price.low_season_weekday_price,
    )
      .toFixed(2)
      .toString();
  }
  if (
    prices?.extra_guest_price?.low_season_weekend_price !==
    Number(values.extra_guest_price.low_season_weekend_price)
      .toFixed(2)
      .toString()
  ) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.extra_guest_price.low_season_weekend_price = Number(
      values.extra_guest_price.low_season_weekend_price,
    )
      .toFixed(2)
      .toString();
  }
  if (
    Number(values.extra_guest_price.min_guests_weekday) !==
    prices?.extra_guest_price?.min_guests_weekday
  ) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.extra_guest_price.min_guests_weekday = Number(
      values.extra_guest_price.min_guests_weekday,
    );
  }
  if (
    Number(values.extra_guest_price.min_guests_weekend) !==
    prices?.extra_guest_price?.min_guests_weekend
  ) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.extra_guest_price.min_guests_weekend = Number(
      values.extra_guest_price.min_guests_weekend,
    );
  }

  let newHasKidsPrice = values.has_kidsPrice;
  if (newHasKidsPrice && !values.ageKidsFree && values.kidsPrice.length === 0) {
    newHasKidsPrice = false;
  }

  if (newHasKidsPrice !== prices.extra_guest_price?.is_kids_price_active) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.extra_guest_price.is_kids_price_active = newHasKidsPrice;
  }

  if (Number(values.ageKidsFree) !== prices.extra_guest_price?.age_kids_free) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.extra_guest_price.age_kids_free = Number(values.ageKidsFree);
  }

  if (
    JSON.stringify(prices.kids_prices) !==
    JSON.stringify(parseKidsPrice(values.kidsPrice))
  ) {
    if (!updatePrice.extra_guest_price) {
      updatePrice.extra_guest_price = {};
    }
    updatePrice.kids_prices = parseKidsPrice(values.kidsPrice);
  }

  return updatePrice;
};

export const createInitialKidsPrice = (
  kidsPrice: KidsPriceType[] | [] | null,
) => {
  let refactorKidsPrice: KidsPriceFormType[] = [];
  if (kidsPrice && kidsPrice.length > 0) {
    kidsPrice.forEach((item) => {
      const newItem: KidsPriceFormType = {
        start_age: item.start_age,
        end_age: item.end_age,
        price: {
          high_season_weekday_price: item.high_season_weekday_price,
          high_season_weekend_price: item.high_season_weekend_price,
          low_season_weekday_price: item.low_season_weekday_price,
          low_season_weekend_price: item.low_season_weekend_price,
        },
      };
      refactorKidsPrice.push(newItem);
    });
  }
  return refactorKidsPrice;
};

const parseKidsPrice = (formKidsPrice: KidsPriceFormType[] | []) => {
  let parseKidspriceArray: KidsPriceType[] = [];
  if (formKidsPrice.length > 0) {
    formKidsPrice.forEach((item) => {
      const newItem: KidsPriceType = {
        start_age: Number(item.start_age),
        end_age: Number(item.end_age),
        high_season_weekday_price: Number(item.price.high_season_weekday_price)
          .toFixed(2)
          .toString(),
        high_season_weekend_price: Number(item.price.high_season_weekend_price)
          .toFixed(2)
          .toString(),
        low_season_weekday_price: Number(item.price.low_season_weekday_price)
          .toFixed(2)
          .toString(),
        low_season_weekend_price: Number(item.price.low_season_weekend_price)
          .toFixed(2)
          .toString(),
      };
      parseKidspriceArray.push(newItem);
    });
  }
  return parseKidspriceArray;
};

export const isPricesEqual = (
  values: PriceFormType,
  initialValues: PriceFormType,
) => {
  if (values.isPriceDynamic !== initialValues.isPriceDynamic) {
    return false;
  }
  if (values.start_date_day !== initialValues.start_date_day) {
    return false;
  }
  if (values.start_date_month !== initialValues.start_date_month) {
    return false;
  }
  if (values.end_date_day !== initialValues.end_date_day) {
    return false;
  }
  if (values.end_date_month !== initialValues.end_date_month) {
    return false;
  }
  if (
    Number(values.base_price.high_season_weekday_price) !==
    Number(initialValues.base_price.high_season_weekday_price)
  ) {
    return false;
  }
  if (
    Number(values.base_price.high_season_weekend_price) !==
    Number(initialValues.base_price.high_season_weekend_price)
  ) {
    return false;
  }
  if (
    Number(values.base_price.low_season_weekday_price) !==
    Number(initialValues.base_price.low_season_weekday_price)
  ) {
    return false;
  }
  if (
    Number(values.base_price.low_season_weekend_price) !==
    Number(initialValues.base_price.low_season_weekend_price)
  ) {
    return false;
  }
  if (values.isAnimalPrice !== initialValues.isAnimalPrice) {
    return false;
  }
  if (Number(values.animalPrice) !== Number(initialValues.animalPrice)) {
    return false;
  }
  if (values.has_kidsPrice !== initialValues.has_kidsPrice) {
    return false;
  }
  if (values.ageKidsFree !== initialValues.ageKidsFree) {
    return false;
  }
  if (
    Number(values.extra_guest_price.high_season_weekday_price) !==
    Number(initialValues.extra_guest_price.high_season_weekday_price)
  ) {
    return false;
  }
  if (
    Number(values.extra_guest_price.high_season_weekend_price) !==
    Number(initialValues.extra_guest_price.high_season_weekend_price)
  ) {
    return false;
  }
  if (
    Number(values.extra_guest_price.low_season_weekday_price) !==
    Number(initialValues.extra_guest_price.low_season_weekday_price)
  ) {
    return false;
  }
  if (
    Number(values.extra_guest_price.low_season_weekend_price) !==
    Number(initialValues.extra_guest_price.low_season_weekend_price)
  ) {
    return false;
  }
  if (
    values.extra_guest_price.min_guests_weekday !==
    initialValues.extra_guest_price.min_guests_weekday
  ) {
    return false;
  }
  if (
    values.extra_guest_price.min_guests_weekend !==
    initialValues.extra_guest_price.min_guests_weekend
  ) {
    return false;
  }
  if (values.kidsPrice.length !== initialValues.kidsPrice.length) {
    return false;
  }
  for (let i = 0; i < values.kidsPrice.length; i++) {
    const initialItem = initialValues.kidsPrice[i];
    const item = values.kidsPrice[i];
    if (item.start_age !== initialItem.start_age) {
      return false;
    }
    if (Number(item.end_age) !== Number(initialItem.end_age)) {
      return false;
    }
    if (
      Number(item.price.high_season_weekday_price) !==
      Number(initialItem.price.high_season_weekday_price)
    ) {
      return false;
    }
    if (
      Number(item.price.high_season_weekend_price) !==
      Number(initialItem.price.high_season_weekend_price)
    ) {
      return false;
    }
    if (
      Number(item.price.low_season_weekday_price) !==
      Number(initialItem.price.low_season_weekday_price)
    ) {
      return false;
    }
    if (
      Number(item.price.low_season_weekend_price) !==
      Number(initialItem.price.low_season_weekend_price)
    ) {
      return false;
    }
  }
  return true;
};
